export default __webpack_public_path__ + "static/01-ranking-shanghai-academic-ranking-of-world-universities-2021-large-44d3ad43007dbddda8680707ca738590.svg";